import { Link, useHistory } from 'react-router-dom';
import { useGetUserInfoQuery } from 'store/services/segmentsApi';
import { useQuery } from 'utils/useQuery';
import { StepsSummary } from './StepsSummary';

export default function WelcomeStep() {
  const history = useHistory();

  const query = useQuery();
  const store_name = query.get('store_name');

  const { data } = useGetUserInfoQuery();

  const hasUserAlreadySelectedPlan = data?.onboard_objectives.find(
    (store) => store.store_name === store_name
  )?.plan_selected;

  return (
    <div className="p-5 lg:mt-20 lg:p-0 lg:max-w-screen-xl lg:mx-auto">
      <div className="lg:flex lg:justify-center lg:mt-6">
        <div className="flex space-x-2">
          <img
            width="64"
            height="64"
            src="/assets/logo-segments.png"
            alt="logo"
            className="w-6 h-6 lg:h-16 lg:w-16"
          />
          <p className="lg:hidden tracking-segments-logo text-segments-dark">
            Segments
          </p>
        </div>
      </div>
      <div className="mx-auto">
        <p className="text-2xl lg:text-[32px] font-bold leading-9 lg:text-center mt-16 lg:mt-6">
          Welcome
        </p>
        <p className="mt-6 text-base leading-6 text-black lg:text-center">
          Thanks for installing Segments — we're excited to have you on board.
          Let's spend a few minutes setting up your account, and setting you up
          for success!
        </p>
      </div>

      <StepsSummary />

      <div className="flex items-center justify-center my-12 space-x-8 ">
        <Link
          to={{
            ...history.location,
            pathname: hasUserAlreadySelectedPlan
              ? '/onboarding/profile'
              : '/onboarding/pricing',
          }}
          className="py-3 font-bold text-white border px-14 lg:px-20 rounded-xl bg-segments-accent-color-1 border-segments-accent-color-1"
        >
          Next
        </Link>
      </div>
    </div>
  );
}
